(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ConexionesDetailController', ConexionesDetailController);

    ConexionesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Conexiones'];

    function ConexionesDetailController($scope, $rootScope, $stateParams, previousState, entity, Conexiones) {
        var vm = this;

        vm.conexiones = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:conexionesUpdate', function(event, result) {
            vm.conexiones = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
